import { Modal, Button } from 'react-bootstrap';
import useT from "../../i18n/useT";

const CreateBoat = ({show, setShow, formData, setFormData, submit, loading, type}) => {
    const t = useT();
    return (
        <Modal show={show} onHide={() => setShow(false)} size='lg' centered>
            <Modal.Header closeButton><h3>{type === "edit" ? t("boats.editTitle") : t("boats.addTitle")}</h3></Modal.Header>
            <Modal.Body>
                <form className='row' onSubmit={submit}>
                    <div className='col-md-6'>
                        <div className='form-group mb-4'>
                            <label>{t("boats.name")}:</label>
                            <input name="name" className='form-control' type='text' required placeholder={t("boats.phName")} value={formData.name} onChange={(e) => setFormData((prev) => ({...prev, name: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group mb-4'>
                            <label>{t("boats.identifier")}:</label>
                            <input name="name" className='form-control' type='text' required placeholder={t("boats.phIdentifier")} value={formData.identification_code} onChange={(e) => setFormData((prev) => ({...prev, identification_code: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group mb-4'>
                            <label>{t("boats.departureDate")}:</label>
                            <input name="name" className='form-control' type='date' value={formData.departure_date} onChange={(e) => setFormData((prev) => ({...prev, departure_date: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group mb-4'>
                            <label>{t("boats.estArrivalDate")}:</label>
                            <input name="name" className='form-control' type='date' value={formData.estimated_arrival_date} onChange={(e) => setFormData((prev) => ({...prev, estimated_arrival_date: e.target.value}))}/>
                        </div>
                    </div>
                    <Modal.Footer>
                        <Button type='submit' variant={loading ? 'secondary' : 'primary'} disabled={loading}>{loading ? <div className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div> : type === "add" ? t("common.addNew") : t("common.save")}</Button>
                        <Button type='button' onClick={() => setShow(false)} variant='danger'>{t("common.close")}</Button>
                    </Modal.Footer>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default CreateBoat;